import { Validator } from '@vista-digital/validator';
import { ButtonUi } from '../../../subcomponents/button/subcomponents/ui';
import { ConfirmationModalUi } from '../../../subcomponents/confirmation-modal/subcomponents/ui';
import { InputUI } from '../../../subcomponents/form/input/input/subcomponents/ui';
import { ModalUi } from '../../../subcomponents/modal/subcomponents/ui';
import { reactComponentValidator } from '../../../validators/react-component';
export const defaultOccSubcomponents = {
    Button: ButtonUi,
    Modal: ModalUi,
    FilmTrailerModal: ModalUi,
    ConfirmationModal: ConfirmationModalUi,
    Input: InputUI
};
export const occSubcomponentsSchema = {
    Button: reactComponentValidator,
    Modal: reactComponentValidator,
    FilmTrailerModal: reactComponentValidator,
    ConfirmationModal: reactComponentValidator,
    Input: reactComponentValidator
};
export const occSubcomponentsValidator = Validator.object(occSubcomponentsSchema);
